import React, { useState } from 'react'
import Header from './Header'
import Footer from './Footer'

const Contact = () => {
  


  let [num,setNum] = useState(0)
  let [message,setMessage] = useState("Good Morning")
  let [clr,setClr] = useState({color:"green"})
  let [message2,setMessage2] = useState("Good Morning")
  let [clr2,setClr2] = useState({color:"green"})


  let decrement = ()=>{
    num--
    setNum(num)
  }
  let increment = ()=>{
    num++
    setNum(num)
  }

  let morning =()=>{
    setMessage("Good Morning")
    setClr({color:"green"})
  }
  let aftnoon =()=>{
    setMessage("Good Afternoon")
    setClr({color:"red"})
  }
  let evening =()=>{
    setMessage("Good Evening")
    setClr({color:"yellow"})
  }
  let night =()=>{
    setMessage("Good night")
    setClr({color:"brown"})
  }

  let wish1 = (x,y)=>{
    setMessage2(x)
    setClr2({color:y})
  }

  return (
    <>
      <Header />
      <h1 className='text-center'>Counter Task</h1>
      <div className="container">
        <div className="row">
          <div className="col-md-6 mx-auto">
            <div className="card">
              <div className="card-header">
                <h3>Counter</h3>
              </div>
              <div className="card-body text-center">
                <h1>{num}</h1>
                <button className='btn btn-danger me-2' onClick={decrement}>Decrement</button>
                <button className='btn btn-success' onClick={increment}>Increment</button>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <h1 className='text-center'>Wish Message</h1>
      <div className="container">
        <div className="row">
          <div className="col-md-6 mx-auto">
            <div className="card">
              <div className="card-header">
                <h3>Wish Message</h3>
              </div>
              <div className="card-body text-center">
                <h1 style={clr}>{message}</h1>
                <button className='btn btn-success me-2' onClick={morning}>Morning</button>
                <button className='btn btn-danger me-2' onClick={aftnoon}>Aftnoon</button>
                <button className='btn btn-warning me-2' onClick={evening}>Evening</button>
                <button className='btn btn-dark me-2' onClick={night}>Night</button>
              </div>
            </div>
            
          </div>
        </div>
      </div>

      <h1 className='text-center'>Wish Message-2</h1>
      <div className="container">
        <div className="row">
          <div className="col-md-6 mx-auto">
            <div className="card">
              <div className="card-header">
                <h3>Wish Message-2</h3>
              </div>
              <div className="card-body text-center">
                <h1 style={clr2}>{message2}</h1>
                <button className='btn btn-success me-2' onClick={()=>wish1("Good Morning","green")}>Morning</button>
                <button className='btn btn-danger me-2' onClick={()=>wish1("Good Aftnoon","red")}>Aftnoon</button>
                <button className='btn btn-warning me-2' onClick={()=>wish1("Good Evening","yellow")}>Evening</button>
                <button className='btn btn-dark me-2' onClick={()=>wish1("Good Night",'brown')}>Night</button>
              </div>
            </div>
            
          </div>
        </div>
      </div>


      
      <Footer />
    </>
  )
}

export default Contact
